module.exports = __webpack_public_path__ + "static/media/Ferguson-Iyara.0c4ada30.pdf";